import React, { useEffect, useState } from "react";
import { arrayOf, bool, number, shape, string } from "prop-types";

import buildingsAdImage from "../../../../../../app/assets/images/header/buildings/NewDev_AdUnit.png";
import buildingsAdImage2x from "../../../../../../app/assets/images/header/buildings/NewDev_AdUnit@2x.png";
import {
  Column,
  Container,
  Dropdown,
  List,
  ListItem,
  ListItemLink,
  Title
} from "../MainNav/Dropdown";
import { useMainNavDropdown } from "../MainNav/hooks";
import { MostViewedListingImage } from "../MostViewedListing";
import { DEFAULT_DROPDOWN_TITLE } from "./constants";
import * as S from "./styled";

const BuyMainNavDropdown = ({
  is_full_width,
  is_wide,
  popular_buildings,
  title,
  trending_building
}) => {
  const [adImageProps, setAdImageProps] = useState({ src: "", srcSet: "" });
  const {
    dropdownRef,
    isActive,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = useMainNavDropdown({
    event_label: "Buildings",
    event_value: trending_building?.id ? `${trending_building.id}` : ""
  });
  const buildingsDataGtm = {
    "data-gtm-header-menu": "Buildings"
  };
  useEffect(() => {
    setAdImageProps({
      src: buildingsAdImage,
      srcSet: `${buildingsAdImage2x} 2x`
    });
  }, []);
  return (
    <>
      <S.BuildingsDropdownButton
        ref={dropdownRef}
        aria-expanded={isActive}
        aria-haspopup="true"
        aria-label={DEFAULT_DROPDOWN_TITLE}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        title={title}
      >
        <Dropdown isActive={isActive} role="tooltip">
          <Container isFullWidth={!!is_full_width} isWide={!!is_wide}>
            <Column>
              <Title>Browse</Title>
              <List hasBottomPadding>
                <ListItem>
                  <ListItemLink href="/new-developments" {...buildingsDataGtm}>
                    New Developments
                  </ListItemLink>
                </ListItem>
              </List>
              <Title>Areas</Title>
              <List>
                <ListItem>
                  <ListItemLink
                    href="/buildings/manhattan"
                    {...buildingsDataGtm}
                  >
                    Manhattan
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/buildings/brooklyn"
                    {...buildingsDataGtm}
                  >
                    Brooklyn
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/buildings/queens" {...buildingsDataGtm}>
                    Queens
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/buildings/bronx" {...buildingsDataGtm}>
                    Bronx
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/buildings/staten-island"
                    {...buildingsDataGtm}
                  >
                    Staten Island
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/buildings/new-jersey"
                    {...buildingsDataGtm}
                  >
                    New Jersey
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/buildings/nyc" {...buildingsDataGtm}>
                    All NYC + NJ
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column>
              <Title>Popular buildings</Title>
              <List>
                {(popular_buildings || []).map((building, ind) => (
                  <ListItem
                    key={
                      `${building?.subject}_${building?.url_for_building}` ||
                      ind
                    }
                  >
                    <ListItemLink
                      href={building?.url_for_building}
                      {...buildingsDataGtm}
                    >
                      {building?.subject}
                    </ListItemLink>
                  </ListItem>
                ))}
                <ListItem>
                  <ListItemLink href="/buildings/all" {...buildingsDataGtm}>
                    View All
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column isLastShort>
              <Title>New developments</Title>
              <List>
                <ListItem>
                  <ListItemLink
                    href="/building/front-york"
                    {...buildingsDataGtm}
                  >
                    85 Jay Street
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/building/graydon-chelsea"
                    {...buildingsDataGtm}
                  >
                    128 West 23rd Street
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/building/77-charlton-street-new_york"
                    {...buildingsDataGtm}
                  >
                    77 Charlton Street
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/building/150-east-78-street-new_york"
                    {...buildingsDataGtm}
                  >
                    150 East 78th Street
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/building/200-amsterdam-avenue-new_york"
                    {...buildingsDataGtm}
                  >
                    200 Amsterdam Avenue
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/building/the-leyton"
                    {...buildingsDataGtm}
                  >
                    1059 Third Avenue
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/building/vu-new-york"
                    {...buildingsDataGtm}
                  >
                    368 Third Avenue
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/building/one-essex-crossing"
                    {...buildingsDataGtm}
                  >
                    202 Broome Street
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/building/one-manhattan-square"
                    {...buildingsDataGtm}
                  >
                    252 South Street
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/buildings/nyc/new_development:new%20development"
                    {...buildingsDataGtm}
                  >
                    View All
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column isAdsShort>
              <div>
                <MostViewedListingImage as="div">
                  <a href="/new-developments">
                    <img
                      alt="Looking for a New Development? Start Your Search"
                      loading="lazy"
                      {...adImageProps}
                    />
                  </a>
                </MostViewedListingImage>
              </div>
            </Column>
          </Container>
        </Dropdown>
      </S.BuildingsDropdownButton>
    </>
  );
};

BuyMainNavDropdown.propTypes = {
  is_wide: bool,
  is_full_width: bool,
  buildings_ad_image: string,
  buildings_ad_image_set: string,
  popular_buildings: arrayOf(
    shape({
      url_for_building: string,
      subject: string
    })
  ),
  trending_building: shape({
    id: number
  }),
  title: string
};

BuyMainNavDropdown.defaultProps = {
  is_wide: false,
  is_full_width: false,
  buildings_ad_image: "",
  buildings_ad_image_set: "",
  popular_buildings: [],
  trending_building: undefined,
  title: DEFAULT_DROPDOWN_TITLE
};

export default BuyMainNavDropdown;
